import { SheetData } from "x-data-spreadsheet";

/** Long format: one row per fruit and region; the Region column is the group column (settings.groupByColumn) */
export const CrossTableSimpleSampleData: SheetData = {
    rows: {
        0: {
            cells: {
                0: { text: "Fruit" },
                1: { text: "Revenue" },
                2: { text: "Region" },
            },
        },
        1: {
            cells: {
                0: { text: "Oranges" },
                1: { text: "91" },
                2: { text: "Europe" },
            },
        },
        2: {
            cells: {
                0: { text: "Oranges" },
                1: { text: "47" },
                2: { text: "America" },
            },
        },
        3: {
            cells: {
                0: { text: "Oranges" },
                1: { text: "16" },
                2: { text: "Asia" },
            },
        },
        4: {
            cells: {
                0: { text: "Oranges" },
                1: { text: "10" },
                2: { text: "Africa" },
            },
        },
        5: {
            cells: {
                0: { text: "Oranges" },
                1: { text: "15" },
                2: { text: "Others" },
            },
        },
        6: {
            cells: {
                0: { text: "Lemons" },
                1: { text: "80" },
                2: { text: "Europe" },
            },
        },
        7: {
            cells: {
                0: { text: "Lemons" },
                1: { text: "50" },
                2: { text: "America" },
            },
        },
        8: {
            cells: {
                0: { text: "Lemons" },
                1: { text: "20" },
                2: { text: "Asia" },
            },
        },
        9: {
            cells: {
                0: { text: "Lemons" },
                1: { text: "24" },
                2: { text: "Africa" },
            },
        },
        10: {
            cells: {
                0: { text: "Lemons" },
                1: { text: "17" },
                2: { text: "Others" },
            },
        },
        11: {
            cells: {
                0: { text: "Bananas" },
                1: { text: "78" },
                2: { text: "Europe" },
            },
        },
        12: {
            cells: {
                0: { text: "Bananas" },
                1: { text: "45" },
                2: { text: "America" },
            },
        },
        13: {
            cells: {
                0: { text: "Bananas" },
                1: { text: "18" },
                2: { text: "Asia" },
            },
        },
        14: {
            cells: {
                0: { text: "Bananas" },
                1: { text: "56" },
                2: { text: "Africa" },
            },
        },
        15: {
            cells: {
                0: { text: "Bananas" },
                1: { text: "9" },
                2: { text: "Others" },
            },
        },
        16: {
            cells: {
                0: { text: "Kiwi" },
                1: { text: "73" },
                2: { text: "Europe" },
            },
        },
        17: {
            cells: {
                0: { text: "Kiwi" },
                1: { text: "42" },
                2: { text: "America" },
            },
        },
        18: {
            cells: {
                0: { text: "Kiwi" },
                1: { text: "17" },
                2: { text: "Asia" },
            },
        },
        19: {
            cells: {
                0: { text: "Kiwi" },
                1: { text: "32" },
                2: { text: "Africa" },
            },
        },
        20: {
            cells: {
                0: { text: "Kiwi" },
                1: { text: "8" },
                2: { text: "Others" },
            },
        },
        21: {
            cells: {
                0: { text: "Apples" },
                1: { text: "74" },
                2: { text: "Europe" },
            },
        },
        22: {
            cells: {
                0: { text: "Apples" },
                1: { text: "32" },
                2: { text: "America" },
            },
        },
        23: {
            cells: {
                0: { text: "Apples" },
                1: { text: "17" },
                2: { text: "Asia" },
            },
        },
        24: {
            cells: {
                0: { text: "Apples" },
                1: { text: "42" },
                2: { text: "Africa" },
            },
        },
        25: {
            cells: {
                0: { text: "Apples" },
                1: { text: "15" },
                2: { text: "Others" },
            },
        },
        26: {
            cells: {
                0: { text: "Melons" },
                1: { text: "79" },
                2: { text: "Europe" },
            },
        },
        27: {
            cells: {
                0: { text: "Melons" },
                1: { text: "44" },
                2: { text: "America" },
            },
        },
        28: {
            cells: {
                0: { text: "Melons" },
                1: { text: "14" },
                2: { text: "Asia" },
            },
        },
        29: {
            cells: {
                0: { text: "Melons" },
                1: { text: "42" },
                2: { text: "Africa" },
            },
        },
        30: {
            cells: {
                0: { text: "Melons" },
                1: { text: "8" },
                2: { text: "Others" },
            },
        },
        31: {
            cells: {
                0: { text: "Pears" },
                1: { text: "71" },
                2: { text: "Europe" },
            },
        },
        32: {
            cells: {
                0: { text: "Pears" },
                1: { text: "21" },
                2: { text: "America" },
            },
        },
        33: {
            cells: {
                0: { text: "Pears" },
                1: { text: "14" },
                2: { text: "Asia" },
            },
        },
        34: {
            cells: {
                0: { text: "Pears" },
                1: { text: "62" },
                2: { text: "Africa" },
            },
        },
        35: {
            cells: {
                0: { text: "Pears" },
                1: { text: "14" },
                2: { text: "Others" },
            },
        },
        36: {
            cells: {
                0: { text: "Grapes" },
                1: { text: "57" },
                2: { text: "Europe" },
            },
        },
        37: {
            cells: {
                0: { text: "Grapes" },
                1: { text: "33" },
                2: { text: "America" },
            },
        },
        38: {
            cells: {
                0: { text: "Grapes" },
                1: { text: "11" },
                2: { text: "Asia" },
            },
        },
        39: {
            cells: {
                0: { text: "Grapes" },
                1: { text: "24" },
                2: { text: "Africa" },
            },
        },
        40: {
            cells: {
                0: { text: "Grapes" },
                1: { text: "9" },
                2: { text: "Others" },
            },
        },
    },
};
